import {
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    FormGroup,
    InputLabel,
    TextField,
    useMediaQuery,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { isEmpty, isNotEmpty } from "../../Utils";
import ErrorMsg from "../../component/ErrorMsg/ErrorMsg";
import { getForm, getParams, getStatus } from "../../redux/selector";

function ApprovalDialog({ formOpen, onSubmit, onClose, action }) {
    const { t, i18n } = useTranslation();
    const { formId, workflowType } = useSelector(getForm());
    const params = useSelector(getParams());
    const formStatus = useSelector(getStatus());
    const [checked, setChecked] = useState(false);
    const [replyMsg, setReplyMsg] = useState([]);
    const [otherMsg, setOtherMsg] = useState("");
    const [workflowRole, setWorkflowRole] = useState([]);
    const [msgDialogOpen, setMsgDialogOpen] = useState(false);
    const [replyMsgInputs, setReplyMsgInputs] = useState({});
    const [replyMsgTimestamps, setReplyMsgTimestamps] = useState({}); // 存储每个文件消息的时间戳
    const hasEmptyForm107Input = formId === "Form107" && replyMsg.some((val) => {
        const attachId = val.split("|")[0];
        return isEmpty(replyMsgInputs[attachId]);
    });
    const disableBtn = [...replyMsg].length + otherMsg.length == 0 || hasEmptyForm107Input;
    const msgObj = JSON.parse(params?.replySlipMsgs || "[]");
    const fullWidth = useMediaQuery("(min-width:600px)");

    let principalOrSupervisorInitOptions = t(
        `${formId}.option.principalOrSupervisor`,
        {
            returnObjects: true,
        }
    );

    const [principalOrSupervisorOption, setPrincipalOrSupervisorOption] =
        useState(principalOrSupervisorInitOptions);

    useEffect(() => {
        if (isNotEmpty(workflowType)) {
            const principalAndSupervisorOption = {
                principalAndSupervisor:
                    principalOrSupervisorInitOptions.principalAndSupervisor,
            };
            const principalAddSupervisorOption = {
                principal: principalOrSupervisorInitOptions.principal,
                supervisor: principalOrSupervisorInitOptions.supervisor,
            };
            switch (workflowType) {
                case "1":
                    setPrincipalOrSupervisorOption(
                        principalAndSupervisorOption
                    );
                    break;
                case "2":
                    setPrincipalOrSupervisorOption(
                        principalAddSupervisorOption
                    );
                    break;
                case "3":
                    setPrincipalOrSupervisorOption(
                        principalAddSupervisorOption
                    );
                    break;
                default:
                    setPrincipalOrSupervisorOption(
                        principalOrSupervisorInitOptions
                    );
                    break;
            }
        }
    }, [workflowType, t]);

    const toggleCheckBoxItem = (value) => {
        let array = [...replyMsg];
        let index = array.indexOf(value);
        if (index > -1) {
            // 取消选中时，移除该文件的消息
            array.splice(index, 1);
            // 清空该文件的输入内容
            const attachId = value.split("|")[0];
            setReplyMsgInputs((prev) => {
                const newInputs = { ...prev };
                delete newInputs[attachId];
                return newInputs;
            });
            // 清空该文件的时间戳
            setReplyMsgTimestamps((prev) => {
                const newTimestamps = { ...prev };
                delete newTimestamps[attachId];
                return newTimestamps;
            });
        } else {
            array.push(value);
        }
        setReplyMsg(array);
    };

    const handleSubmit = () => {
        if (formId === "Form104" && action === "return") {
            if (isNotEmpty(workflowRole)) {
                onSubmit({
                    msg: [...replyMsg, otherMsg].filter(isNotEmpty).join("\n"),
                    workflowRole,
                });
            }
        } else if (formId === "Form107" && (action === "return" || action === "reject")) {
            // Form107 使用新的 JSON 格式：List<Map>
            const msgList = [];
            
            // 添加全局消息（如果有）
            if (isNotEmpty(otherMsg)) {
                msgList.push({
                    attachId: "GLOBAL",
                    msg: otherMsg.replace(/^OTHER_REPLY_MSG:/, ""), // 移除前缀
                    dateTime: Date.now(),
                });
            }
            
            // 添加每个文件的消息
            replyMsg.forEach((val) => {
                const parts = val.split("|");
                const attachId = parts[0];
                const customMsg = replyMsgInputs[attachId] || "";
                const timestamp = replyMsgTimestamps[attachId] || Date.now();
                
                if (isNotEmpty(customMsg)) {
                    msgList.push({
                        attachId: attachId,
                        msg: customMsg,
                        dateTime: timestamp,
                    });
                }
            });
            
            // 将 List<Map> 转换为 JSON 字符串
            onSubmit({
                msg: JSON.stringify(msgList),
            });
        } else {
            onSubmit({
                msg: [...replyMsg, otherMsg].filter(isNotEmpty).join("\n"),
            });
        }
    };

    const handleClose = () => {
        setReplyMsg([]);
        setOtherMsg("");
        setReplyMsgInputs({});
        setReplyMsgTimestamps({}); // 清空时间戳
        setMsgDialogOpen(false);
        onClose();
    };

    return (
        <React.Fragment>
            <Dialog
                // onClose={handleClose}
                aria-labelledby="approval-dialog-title"
                open={formOpen}
                fullWidth={fullWidth}
            >
                <DialogTitle id="approval-dialog-title">
                    {t("common.reply.title")}
                </DialogTitle>
                <DialogContent>
                    {formId === "Form104" && action === "return" && (
                        <Box mb={6}>
                            <Box mb={4}>
                                <InputLabel shrink>
                                    <Box>{t("Form104.label.appliantRole")}</Box>
                                </InputLabel>
                            </Box>
                            <FormGroup row>
                                {Object.entries(
                                    principalOrSupervisorOption
                                ).map(([val, modeName]) => (
                                    <Box key={val}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={workflowRole.includes(
                                                        val
                                                    )}
                                                    onChange={() => {
                                                        const selectNeedValue =
                                                            workflowRole;
                                                        if (
                                                            selectNeedValue?.includes(
                                                                val
                                                            )
                                                        ) {
                                                            const nextValues =
                                                                selectNeedValue?.filter(
                                                                    (value) =>
                                                                        value !==
                                                                        val
                                                                );
                                                            setWorkflowRole(
                                                                nextValues
                                                            );
                                                        } else {
                                                            const nextValues = [
                                                                ...selectNeedValue,
                                                                val,
                                                            ];
                                                            setWorkflowRole(
                                                                nextValues
                                                            );
                                                        }
                                                    }}
                                                    value={val}
                                                />
                                            }
                                            label={modeName}
                                        />
                                    </Box>
                                ))}
                            </FormGroup>
                            {/* <RadioGroup
                                row
                                aria-label="principalOrSupervisor"
                                value={workflowRole}
                                onChange={(e) => {
                                    setWorkflowRole(e.target.value);
                                }}
                                inputProps={{
                                    "aria-labelledby": "principalOrSupervisor",
                                }}
                            >
                                {Object.entries(
                                    principalOrSupervisorOption
                                ).map(([key, value]) => (
                                    <FormControlLabel
                                        key={key}
                                        value={key}
                                        control={
                                            <Radio
                                                checkedIcon={<CheckBoxIcon />}
                                                icon={
                                                    <CheckBoxOutlineBlankIcon />
                                                }
                                            />
                                        }
                                        label={value}
                                    />
                                ))}
                            </RadioGroup> */}
                            {isEmpty(workflowRole) && (
                                <ErrorMsg
                                    message={t("Form104.errorMsg.appliantRole")}
                                />
                            )}
                        </Box>
                    )}
                    <FormGroup>
                        {action === "reject"
                            ? t("common.reply.haveRejectReminder")
                            : formId === "Form104"
                            ? t("Form104.reply.haveReturnReminder")
                            : t("common.reply.haveReturnReminder")}
                    </FormGroup>
                </DialogContent>
                <DialogActions>
                    <Button
                        autoFocus
                        onClick={() => {
                            if (formId === "Form104" && action === "return") {
                                if (isNotEmpty(workflowRole)) {
                                    setMsgDialogOpen(true);
                                }
                            } else {
                                setMsgDialogOpen(true);
                            }
                        }}
                    >
                        <b>{t("common.yes")}</b>
                    </Button>
                    {/* Form107 不显示 "just return" 按钮 */}
                    {!(formId === "Form107" && action === "return") && (
                        <Button autoFocus onClick={handleSubmit}>
                            <b>
                                {action === "reject"
                                    ? t("common.reply.justReject")
                                    : t("common.reply.justReturn")}
                            </b>
                        </Button>
                    )}
                    <Button autoFocus onClick={handleClose}>
                        <b>{t("common.button.back")}</b>
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                // onClose={handleClose}
                aria-labelledby="approval-dialog-title"
                open={msgDialogOpen}
                fullWidth={fullWidth}
            >
                <DialogTitle id="approval-dialog-title">
                    {t("common.reply.title")}
                </DialogTitle>
                <DialogContent>
                    <FormGroup>
                        {formId !== "Form107" &&
                            (formStatus === 9 || formStatus === 10) &&
                            msgObj.map((item, index) => (
                                <FormControlLabel
                                    key={index}
                                    control={<Checkbox />}
                                    label={item.value}
                                    onChange={() =>
                                        toggleCheckBoxItem(item.value)
                                    }
                                />
                            ))}
                        {formId === "Form107" &&
                            (formStatus === 9 || formStatus === 10) &&
                            (action === "return" || action === "reject") &&
                            msgObj.map((item, index) => {
                                const attachId = item.attachId;
                                const fileName = item.fileName;
                                // 使用 attachId 作为唯一标识
                                const itemKey = `${attachId}|${fileName}`;
                                const isItemChecked = replyMsg.includes(
                                    itemKey
                                );
                                return (
                                    <Box
                                        key={index}
                                        display="flex"
                                        alignItems="center"
                                        mb={1}
                                    >
                                        <FormControlLabel
                                            control={<Checkbox />}
                                            label={fileName}
                                            onChange={() =>
                                                toggleCheckBoxItem(itemKey)
                                            }
                                        />
                                        <TextField
                                            size="small"
                                            variant="standard"
                                            placeholder={t(
                                                "common.reply.inputMessage",
                                                {
                                                    defaultValue:
                                                        "Please enter message",
                                                }
                                            )}
                                            disabled={!isItemChecked}
                                            error={isItemChecked && isEmpty(replyMsgInputs[attachId])}
                                            value={
                                                replyMsgInputs[attachId] || ""
                                            }
                                            onChange={(e) => {
                                                // 更新消息内容
                                                setReplyMsgInputs({
                                                    ...replyMsgInputs,
                                                    [attachId]: e.target.value,
                                                });
                                                // 更新时间戳（每次输入都更新为当前时间）
                                                setReplyMsgTimestamps({
                                                    ...replyMsgTimestamps,
                                                    [attachId]: Date.now(),
                                                });
                                            }}
                                            inputProps={{
                                                maxLength: 1000,
                                            }}
                                            style={{ flex: 1 }}
                                        />
                                    </Box>
                                );
                            })}

                        {/* {formId !== "Form014" ||
                            (formStatus === 9 || formStatus === 10) &&
                                
                                )} */}
                        {formId !== "Form107" &&
                            (formStatus === 9 || formStatus === 10) && (
                                <FormControlLabel
                                    control={<Checkbox checked={checked} />}
                                    label={t("common.reply.other")}
                                    onChange={() => {
                                        setOtherMsg("");
                                        setChecked(!checked);
                                    }}
                                />
                            )}

                        {(checked ||
                            !(formStatus === 9 || formStatus === 10)) && (
                            <TextField
                                placeholder={t("common.reply.specify")}
                                onChange={(e) => {
                                    setOtherMsg(e.target.value);
                                    // 全局消息的时间戳存储在 "GLOBAL" key 中
                                    if (isNotEmpty(e.target.value)) {
                                        setReplyMsgTimestamps({
                                            ...replyMsgTimestamps,
                                            GLOBAL: Date.now(),
                                        });
                                    }
                                }}
                                inputProps={{ maxLength: 255 }}
                                // maxRows={20}
                            />
                        )}
                    </FormGroup>
                </DialogContent>
                <DialogActions>
                    <Button
                        autoFocus
                        onClick={handleSubmit}
                        disabled={disableBtn}
                    >
                        <b>{t("common.button.send")}</b>
                    </Button>
                    <Button autoFocus onClick={handleClose}>
                        <b>{t("common.button.back")}</b>
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
export default ApprovalDialog;
